module.exports = __webpack_public_path__ + "img/BonofDex.b2df4cd7.png";